<template>
  <div class="object-filter">
    <div class="object-filter__item">
      <label for="objectFilterSearchObjectNameId">
        {{ $t("objects_filter_by_name") }}
      </label>
      <el-input
        id="objectFilterSearchObjectNameId"
        :placeholder="$t('objects_filter_by_name_holder')"
        v-model="objectName"
        clearable
        @input="changeFilter('name')"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <div class="object-filter__item">
      <label for="objectFilterContent">
        {{ $t("objects_filter_by_content") }}
      </label>
      <el-select
        id="objectFilterContent"
        v-model="content"
        filterable
        @change="changeFilter"
      >
        <el-option
          v-for="item in contents"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="object-filter__item">
      <label for="objectFilterCountryId">
        {{ $t("objects_filter_by_country") }}
      </label>
      <el-select
        id="objectFilterCountryId"
        v-model="country"
        placeholder="Select"
        filterable
        clearable
        @change="changeFilter"
      >
        <el-option
          v-for="item in countries"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="object-filter__item">
      <label for="objectFilterCityId">
        {{ $t("objects_filter_by_city") }}
      </label>
      <el-select
        id="objectFilterCityId"
        v-model="city"
        placeholder="Select"
        filterable
        clearable
        @change="changeFilter"
      >
        <el-option
          v-for="item in cities"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="object-filter__item">
      <label for="objectFilterTypeId">
        {{ $t("objects_filter_by_type") }}
      </label>
      <el-select
        id="objectFilterTypeId"
        v-model="objectType"
        filterable
        clearable
        @change="changeFilter"
      >
        <el-option
          v-for="item in objectTypes"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "ObjectFilter",
  props: {
    countries: Array,
    cities: Array,
    objectTypes: Array,
    filter: Object
  },
  data() {
    return {
      objectName: "",
      country: "",
      city: "",
      objectType: "",
      content: 2
    };
  },
  components: {},
  computed: {
    contents() {
      return [
        {
          id: 2,
          name: this.$t("objects_filter_by_content_val_1")
        },
        {
          id: 1,
          name: this.$t("objects_filter_by_content_val_2")
        },
        {
          id: 0,
          name: this.$t("objects_filter_by_content_val_3")
        }
      ];
    }
  },
  methods: {
    changeFilter(val) {
      if (
        !val ||
        (val === "name" &&
          (this.objectName.length === 0 || this.objectName.length > 2)) ||
        (val && val !== "name")
      ) {
        this.$emit("change", {
          name: this.objectName.length > 2 ? this.objectName : "",
          countryId: this.country === "" ? undefined : this.country,
          cityId: this.city === "" ? undefined : this.city,
          type: this.objectType === "" ? undefined : this.objectType,
          content: this.content
        });
      }
    },
    presetFilter() {
      this.country =
        this.filter.countryId === undefined ? "" : this.filter.countryId;
      this.city = this.filter.cityId === undefined ? "" : this.filter.cityId;
      this.objectType = this.filter.type === undefined ? "" : this.filter.type;
      this.content =
        this.filter.content === undefined ? 2 : this.filter.content;
    }
  },
  mounted() {
    this.presetFilter();
  },
  watch: {
    filter: {
      handler: function () {
        this.presetFilter();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.object-filter {
  .object-filter__item {
    max-width: 230px;
    padding-left: 5px;
  }

  .object-filter__item:first-child {
    padding-left: 0;
  }

  label {
    font-size: 12px;
  }
}
</style>
